import { Grid2, Typography } from "@mui/material";
import ExpandableTypography from "./ExpandableTypography";

const EmergencyPlanningDetail = ({ formData }) => {
  const emergencyPlanningLabels = {
    priorityLevel: "Priority Level",
    stearRegistration: "STEAR (State of Texas Emergency Assistance Registry)",
    notes: "Notes",
  };
  return (
    <>
      <Typography variant="h4" color="default.main">
        Emergency Planning
      </Typography>
      <Grid2 container spacing={3} mt={3}>
        {Object.entries(emergencyPlanningLabels).map(([key, label]) => {
          const value = formData?.emergencyPlanningSection0?.[key];

          // Special case for boolean values like stearRegistration
          if (key === "stearRegistration") {
            return (
              <Grid2 size={{ xs: 12, sm: 6 }} key={key}>
                <Typography variant="body2" color="default.main" mb={0.5}>
                  {label}
                </Typography>
                <Typography variant="body1" color="default.light">
                  {value ? "Yes" : "No"}
                </Typography>
              </Grid2>
            );
          }

          return (
            <Grid2 size={{ xs: 12, sm: 6 }} key={key}>
              <Typography variant="body2" color="default.main" mb={0.5}>
                {label}
              </Typography>
              <ExpandableTypography chunkSize={300}>
                {value || "-"}
              </ExpandableTypography>
            </Grid2>
          );
        })}
      </Grid2>
    </>
  );
};
export default EmergencyPlanningDetail;